<template>
        <div class="topbar-patient-info-content" >
        <span>
            {{ patientProfileData.firstName }} {{ patientProfileData.name }}
        </span>
            <span v-show="(patientProfileData.firstName || patientProfileData.name) && priorityPatientProfileData.length > 0"> | </span>
            <span>{{priorityPatientProfileData.join(" | ") }}</span>
        </div>

</template>

<!-- ################################################################## -->

<script>
    import {mapGetters} from 'vuex';

    export default {
        name: 'PatientInfo',

        computed: {
            ...mapGetters({
                patientProfileData: 'AssessmentStartStore/getPatientProfileData',
                startQuestionsAnswerList: 'AssessmentStartStore/getStartQuestionsAnswerList',
                priorityPatientProfileData: 'AssessmentStartStore/getPriorityStartQuestionsAnswerList'
            })
        }
    }
</script>

<!-- ################################################################## -->

<style lang="scss">

    .topbar-patient-info-content {
        font-weight: $font-weight-regular;
        color: $color-body-text;
    }

    .topbar-patient-info-content.patient-info-priority-list {
        position: fixed;
        left: 45px !important;
        margin-top: 12px;
        // SMASSDEV - 1119
        font-size: $font-size-extra-small;
        // word-spacing: $word-spacing-extra-small;
        // line-height: $line-height-extra-small;
        // letter-spacing: $letter-spacing-extra-small;
    }

</style>




// WEBPACK FOOTER //
// src/common/components/shared/PatientInfo.vue